import { LinearProgress } from "@mui/material";
import Image from "next/legacy/image";
import logo from "public/images/OPT-Primary-Black-min.svg";

const FullPageSpinner = ({ message }: { message?: string }) => (
	<div
		className="flex-col ai-c gap-3 jc-c"
		style={{ minHeight: "100vh" }}
		data-testid="full-page-spinner"
	>
		<Image
			src={logo}
			alt="Optera Logo"
			width={177}
			height={48}
			layout="fixed"
		/>
		<div style={{ width: "60%" }}>
			<LinearProgress />
		</div>
		{message ? <p>{message}</p> : null}
	</div>
);

export default FullPageSpinner;
